require('./bootstrap');
require('./vue');
require('./bwpublisher');
require('./cart');

$(function () {
	// Tracking ID Search

	$('#search').on('click', function(e) {
		e.preventDefault();
		jobTrackingURL();
	});

	$('#tracking-id').on('keyup', function(e) {
		if (e.key == 'Enter') {
			e.preventDefault();
			jobTrackingURL();
		}
	});


	// Highlight active nav items

	let $href = window.location.href.split('?')[0],
		$origin = window.location.origin + '/';

	if ($href != $origin) {
		$('a[href*="' + $href + '"]').each(function() {
			$(this).addClass('active');
		});
	}
});

function jobTrackingURL() {
	if ($('#tracking-id').val()) {
		let id = $('#tracking-id').val(),
			href = $('#search').attr('href').replace(/{trackingid}/g, id);
		window.location.href = href;
	}
}
